import { useEffect, useState } from 'react';
import { ReduxStoreBridge } from './redux-bridge';
export var useReduxSelector = function (key) {
    var _a = useState(ReduxStoreBridge.getOnce(key)), value = _a[0], setValue = _a[1];
    useEffect(function () {
        var unsubscribe = ReduxStoreBridge.subscribe(key, function (nextValue) {
            setValue(nextValue);
        });
        return function () {
            unsubscribe();
        };
    }, []);
    return value;
};
